import type { TFurnitureStatus } from "types/elevationReferences.type"

const diamondPath =
	"M1.35337 5.14984C1.24135 5.26175 1.15248 5.39464 1.09184 5.54092C1.03121 5.6872 1 5.84399 1 6.00234C1 6.16068 1.03121 6.31748 1.09184 6.46376C1.15248 6.61003 1.24135 6.74293 1.35337 6.85484L5.14837 10.6498C5.26028 10.7619 5.39318 10.8507 5.53945 10.9114C5.68573 10.972 5.84253 11.0032 6.00087 11.0032C6.15922 11.0032 6.31601 10.972 6.46229 10.9114C6.60857 10.8507 6.74146 10.7619 6.85337 10.6498L10.6484 6.85484C10.7604 6.74293 10.8493 6.61003 10.9099 6.46376C10.9705 6.31748 11.0017 6.16068 11.0017 6.00234C11.0017 5.84399 10.9705 5.6872 10.9099 5.54092C10.8493 5.39464 10.7604 5.26175 10.6484 5.14984L6.85337 1.35484C6.74146 1.24281 6.60857 1.15394 6.46229 1.09331C6.31601 1.03267 6.15922 1.00146 6.00087 1.00146C5.84253 1.00146 5.68573 1.03267 5.53945 1.09331C5.39318 1.15394 5.26028 1.24281 5.14837 1.35484L1.35337 5.14984Z"

const STATUS_COLOR: Record<TFurnitureStatus, { stroke: string; fill: string }> = {
	work_in_progress: { stroke: "var(--clr-midGray)", fill: "none" },
	reviewed: { stroke: "var(--clr-main)", fill: "var(--clr-quotationIconReviewedBg)" },
	in_quotation: {
		stroke: "var(--clr-quotationIconInQuotation)",
		fill: "var(--clr-quotationIconInQuotationBg)",
	},
}

type Props = { status?: TFurnitureStatus }

export const FurnitureStatusIcon = ({ status = "work_in_progress" }: Props) => {
	const { stroke, fill } = STATUS_COLOR[status]

	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d={diamondPath}
				fill={fill}
				stroke={stroke}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
